import BOSFilterMultiselect from 'Components/Generic/BOSMultiselect/BOSFilterMultiselect';
import { useOrgContext } from 'Data/context/Organizations';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';

const OrganizationMultiselect = ({
  onSelectedOrganizationsUpdate,
  defaultSelectedItems,
  labelText = 'Core Facility',
  hideLabel = false,
  maxWidth = 280,
  autofocus = true,
  excludedIds,
  includeFunc,
  ...props
}) => {
  const [selectedOrgs, setSelectedOrgs] = useState(defaultSelectedItems || []);
  const { getFilteredList } = useOrgContext();
  let filteredList = getFilteredList({ excludedIds, includeFunc });

  useEffect(() => {
    onSelectedOrganizationsUpdate &&
      onSelectedOrganizationsUpdate(selectedOrgs);
  }, [selectedOrgs]);

  const onSelectionChange = (orgs) => {
    setSelectedOrgs(orgs);
  };

  return (
    <BOSFilterMultiselect
      labelText={!hideLabel ? labelText : ''}
      listData={filteredList}
      onSelectionUpdate={onSelectionChange}
      placeholder='Select Core(s)...'
      defaultSelectedItems={defaultSelectedItems}
      maxWidth={maxWidth}
      autofocus={autofocus}
      searchFunction={(org) => {
        return `${org.name} ${org.short_name}`;
      }}
      {...props}
    />
  );
};

OrganizationMultiselect.propTypes = {
  onSelectedOrganizationsUpdate: PropTypes.func,
  defaultSelectedItems: PropTypes.array,
  excludedIds: PropTypes.array,
  labelText: PropTypes.string,
  hideLabel: PropTypes.bool,
  maxWidth: PropTypes.number,
  autofocus: PropTypes.bool,
  includeFunc: PropTypes.func,
};

export default OrganizationMultiselect;
